<template>
  <div class="industry">
    <div id="heading">
      <div class="header-icon fa fa-industry"></div>
      <h1>Coverage for Specific Industries</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>Specialized Protection for your Industry</h2>
          </div>

          <p>Every industry has specific needs when it comes to insurance. Industry-specific risks make it impossible
            for insurance companies to lump together one insurance plan for every business. At SIG & Associates, we
            understand that being unique is what makes your business successful across the board. That’s why we provide
            industry-specific insurance options for businesses of all types. </p>

          <p>Check out the multitude of industries we cover at SIG & Associates:</p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Accounting firms
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Alarm contractors
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Arborists
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Construction
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Contractors / specialty trade
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Craft breweries
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Educational facilities
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Financial institutions
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Healthcare facilities
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Healthcare practices
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Law firms
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Life science
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Limousine services
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Livestock
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Maintenance contractors
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Manufacturing&nbsp;
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Marine
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Maritime employers
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Media &amp; advertising
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Orthotics &amp; prosthetics
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Pools &amp; spas
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Printers &amp; publishers
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Railroad contractors &amp; manufacturers
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Real estate
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Retail
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              School bus contractors
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Scrap metal
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Security guards
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Self-storage facilities
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Septic contractors
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Technology services
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Tow trucks &amp; auto transporters
            </li>
            <li class="list-item link" @click="handleModal()" data-page="temp">
              Water well driller
            </li>
          </ul>

          <p><small><i>SIG & Associates provides industry-specific insurance to businesses in Wichita Falls, Haslet,
            Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import industryHelper from '../helpers/industryHelper.js'

Object.defineProperty(Vue.prototype, '$industryHelper', {value: industryHelper})
Vue.component('modal')

export default {
  name: 'Business',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$industryHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Industry.vue